import React, { Component } from "react";
import { GetNominationTeams } from "../Service";
import classnames from "classnames";
import { Row } from "react-bootstrap";
import {
  tenantDomain,
  exportCsvError,
  notSelectedTeamError,
  apiUnauthorizedError,
} from "../message";
import CAlert from "./CAlert";
import { GetUserInFo } from "../adalconfig";

const regex = new RegExp("^[0-9]+$");
interface IState {
  teams: Array<any>;
  dataloaded: boolean;
  childselectedgroupId: string;
  validLicense: boolean;
  alertmessage: string;
  showalert: boolean;
  alerttype: string;
  alertheading: string;
  isAdmin: boolean;
  loaderTeam: boolean;
  selectdTeam: any;
}

interface IProps {
  parentCallback: (groupid: string, licencecount: number) => void;
  resetGroupId: () => void;
  setalertparameters: (message: string, type: string, heading: string) => void;
  styleName: string;
  addLicenses: boolean;
  parentselectedgroupid: string;
  availableOwners: number;
  loading?: boolean;
}
class TeamList extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      teams: [],
      dataloaded: false,
      childselectedgroupId: this.props.parentselectedgroupid,
      validLicense: false,
      alertmessage: "",
      showalert: false,
      alerttype: "",
      alertheading: "",
      isAdmin: false,
      loaderTeam: false,
      selectdTeam: null,
    };
    this.bindData = this.bindData.bind(this);
    this.handleTeamChange = this.handleTeamChange.bind(this);
    this.getLicenses = this.getLicenses.bind(this);
    this.setLicenses = this.setLicenses.bind(this);
  }

  async componentDidMount() {
    this.bindData();
  }

  async bindData() {
    try {
      this.setState({ loaderTeam: true });
      await GetNominationTeams().subscribe((teamslist: any) => {
        this.setState({ loaderTeam: false });
        if (teamslist.status === "Error") {
          let userUPN: string = GetUserInFo().profile?.upn;
          if (
            !userUPN.toLowerCase().includes("@" + `${tenantDomain}`) &&
            teamslist?.message?.response?.status === 401
          ) {
            this.setalertparameters(apiUnauthorizedError.replace("{tenantDomain}",tenantDomain), "error", "Error");
          } else {
            this.setalertparameters(teamslist.message, "error", "Error");
          }
          return;
        }
        if (teamslist.length === 1) {
          this.props.parentCallback(teamslist[0], teamslist[0].addLicenses);
          this.setState({
            teams: teamslist,
            dataloaded: true,
            childselectedgroupId: teamslist[0].teamGUID,
            isAdmin: teamslist[0].isAdmin,
          });
        } else if (teamslist.length > 1) {
          if (!this.props.parentselectedgroupid) {
            this.props.resetGroupId();
            this.setState({
              teams: teamslist,
              dataloaded: true,
              childselectedgroupId: "",
            });
          } else {
            let team = teamslist.find(
              (x: any) => x.teamGUID === this.props.parentselectedgroupid
            );
            this.props.parentCallback(team, team.addLicenses);
            this.setState({
              teams: teamslist,
              dataloaded: true,
              childselectedgroupId: team.teamGUID,
              isAdmin: team.isAdmin,
            });
          }
        }
      });
    } catch {
      this.setalertparameters(exportCsvError, "error", "Error");
    }
  }
  handleTeamChange(event: any) {
    try {
      if (event.target.selectedIndex > 0) {
        this.setState({
          childselectedgroupId: this.state.teams[event.target.selectedIndex - 1]
            .teamGUID,
          isAdmin: this.state.teams[event.target.selectedIndex - 1].isAdmin,
          selectdTeam: this.state.teams[event.target.selectedIndex - 1],
        });
        this.props.parentCallback(
          this.state.teams[event.target.selectedIndex - 1],
          this.state.teams[event.target.selectedIndex - 1]?.addLicenses
        );
      } else {
        this.setalertparameters(notSelectedTeamError, "error", "Error");
      }
    } catch {
      this.setalertparameters(exportCsvError, "error", "Error");
    }
  }

  getLicenses(): number {
    try {
      let licenses = this.state.teams.find(
        (x: any) => x.teamGUID === this.state.childselectedgroupId
      ).addLicenses;
      return licenses + 5;
    } catch {
      this.setalertparameters(exportCsvError, "error", "Error");
      return 0;
    }
  }

  setLicenses(Licences: string) {
    try {
      let tempteams = [...this.state.teams];
      let teaminx = this.state.teams.findIndex(
        (x: any) => x.teamGUID === this.state.childselectedgroupId
      );
      tempteams[teaminx].addLicenses = Licences;
      let valid = !regex.test(Licences);
      this.setState({ teams: tempteams, validLicense: valid });
    } catch {
      this.setalertparameters(exportCsvError, "error", "Error");
    }
  }
  
  async setalertparameters(
    message: string,
    type: string = "warning",
    heading: string = "Warning"
  ) {
    this.setState({
      alertmessage: message,
      alerttype: type,
      alertheading: heading,
      showalert: true,
    });
  }

  render() {
    return (
      <Row style={{ margin: "0px", width: "100%" }}>
        <div
          className={classnames(
            `${this.props.styleName} ${
              this.props.addLicenses &&
              (this.state.childselectedgroupId || this.state.isAdmin)
                ? "col-6"
                : "col-12"
            } teamslist`
          )}
        >
          <div className="input-group-prepend">
            <label className="input-group-text" htmlFor="Team">
              Your Teams <span className="text-danger">*</span>
            </label>
          </div>
          <select
            className="custom-select"
            id="Team"
            value={this.state.childselectedgroupId || ""}
            onChange={this.handleTeamChange}
          >
            <option value="">Choose...</option>
            {this.state.teams.map((team, inx) => (
              <option id={team.teamGUID} key={inx} value={team.teamGUID}>
                {team.title}
              </option>
            ))}
          </select>
          {this.state.loaderTeam && (
            <div className="icon-container">
              <i className="loader"></i>
            </div>
          )}
        </div>
        {this.props.addLicenses &&
          (this.state.childselectedgroupId || this.state.isAdmin) && (
            <div
              className={classnames(
                `${this.props.styleName} ${
                  this.props.addLicenses ? "col-6" : ""
                }`
              )}
            >
              <div className="input-group-prepend">
                <span className="input-group-text">Owners Available</span>
              </div>
              <input
                type="text"
                aria-label="First name"
                disabled={true}
                value={
                  this.props.loading
                    ? ""
                    : `${
                        this.getLicenses() - this.props.availableOwners
                      }/${this.getLicenses()}`
                }
                className="form-control"
                onChange={(event: any) => this.setLicenses(event.target.value)}
              />
            </div>
          )}
        <div className="w-100">
          {this.state.teams && this.state.validLicense && (
            <span className="license-validation float-right">
              Enter only numberic values
            </span>
          )}
        </div>
        {this.state.showalert && (
          <CAlert
            message={this.state.alertmessage}
            heading={this.state.alertheading}
            type={this.state.alerttype}
            closecallback={() => this.setState({ showalert: false })}
          />
        )}
      </Row>
    );
  }
}

export default TeamList;
